"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
var _objectSpread2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _regeneratorRuntime2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
var _asyncToGenerator2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _categoryProduct = require("@/api/category-product");
var _SingleImage = _interopRequireDefault(require("@/components/Upload/SingleImage.vue"));
var CategoryProductModal = /*#__PURE__*/function (_Vue) {
  function CategoryProductModal() {
    var _this;
    (0, _classCallCheck2.default)(this, CategoryProductModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = (0, _callSuper2.default)(this, CategoryProductModal, [].concat(args));
    (0, _defineProperty2.default)(_this, "levelSelected", void 0);
    (0, _defineProperty2.default)(_this, "queryLevel", void 0);
    (0, _defineProperty2.default)(_this, "$refs", void 0);
    (0, _defineProperty2.default)(_this, "LevelCategory", [{
      label: "Level 1",
      value: 1
    }, {
      label: "Level 2",
      value: 2
    }, {
      label: "Level 3",
      value: 3
    }]);
    (0, _defineProperty2.default)(_this, "loadingSubmit", false);
    (0, _defineProperty2.default)(_this, "visible", false);
    (0, _defineProperty2.default)(_this, "form", {});
    (0, _defineProperty2.default)(_this, "rules", {
      name: {
        required: true,
        message: "Trường này bắt buộc",
        trigger: "submit"
      }
    });
    (0, _defineProperty2.default)(_this, "status", "create");
    (0, _defineProperty2.default)(_this, "parents1", []);
    return _this;
  }
  (0, _inherits2.default)(CategoryProductModal, _Vue);
  return (0, _createClass2.default)(CategoryProductModal, [{
    key: "fetchParents",
    value: function fetchParents() {}
  }, {
    key: "uploadSuccess",
    value: function uploadSuccess(path) {
      this.$set(this.form, "thumbnail", path);
    }
  }, {
    key: "handleDelete",
    value: function () {
      var _handleDelete = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return this.$confirm("Confirm delete this category?", "Warning", {
                cancelButtonText: "No",
                confirmButtonText: "Delete",
                type: "warning"
              });
            case 3:
              this.loadingSubmit = true;
              _context.next = 6;
              return _categoryProduct.categoryProductApi.remove(this.form.id);
            case 6:
              this.$notify.success({
                title: "Delete category",
                message: "Successfully"
              });
              this.visible = false;
              this.$emit("submit:success");
            case 9:
              _context.prev = 9;
              this.loadingSubmit = false;
              return _context.finish(9);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0,, 9, 12]]);
      }));
      function handleDelete() {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }()
  }, {
    key: "createData",
    value: function () {
      var _createData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
        var valid;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.$refs.form.validate();
            case 2:
              valid = _context2.sent;
              if (!valid) {
                _context2.next = 14;
                break;
              }
              _context2.prev = 4;
              this.loadingSubmit = true;
              _context2.next = 8;
              return _categoryProduct.categoryProductApi.create({
                productCategory: (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.form), this.queryLevel), {}, {
                  level: this.levelSelected
                })
              });
            case 8:
              this.$notify({
                title: "Create category",
                message: "Successfully",
                type: "success"
              });
              this.$emit("submit:success");
              this.visible = false;
            case 11:
              _context2.prev = 11;
              this.loadingSubmit = false;
              return _context2.finish(11);
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4,, 11, 14]]);
      }));
      function createData() {
        return _createData.apply(this, arguments);
      }
      return createData;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        var valid;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.$refs.form.validate();
            case 2:
              valid = _context3.sent;
              if (!valid) {
                _context3.next = 14;
                break;
              }
              _context3.prev = 4;
              this.loadingSubmit = true;
              _context3.next = 8;
              return _categoryProduct.categoryProductApi.update(this.form.id, {
                productCategory: this.form
              });
            case 8:
              this.$notify({
                title: "Update category",
                message: "Successfully",
                type: "success"
              });
              this.$emit("submit:success");
              this.visible = false;
            case 11:
              _context3.prev = 11;
              this.loadingSubmit = false;
              return _context3.finish(11);
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4,, 11, 14]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "handleCreate",
    value: function handleCreate() {
      this.visible = true;
      this.status = "create";
      this.form = {};
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate(data) {
      this.form = (0, _objectSpread2.default)({}, data);
      this.visible = true;
      this.status = "update";
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CategoryProductModal.prototype, "levelSelected", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)()], CategoryProductModal.prototype, "queryLevel", void 0);
CategoryProductModal = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    SingleImage: _SingleImage.default
  }
})], CategoryProductModal);
var _default = exports.default = CategoryProductModal;